import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PARKING_WAIVER: AppRouteRecordRaw = {
  path: '/parking-waiver',
  name: 'parking-waiver',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '停车减免管理',
    icon: 'icon-list',
    requiresAuth: true,
    order: 10,
  },
  children: [
    {
      path: 'config',
      alias: '/parking-waiver/config/index',
      name: 'ParkingWaiverConfig',
      component: () => import('@/views/parking-waiver/config/index.vue'),
      meta: {
        locale: '道闸配置',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'record',
      alias: '/parking-waiver/record/index',
      name: 'ParkingWaiverRecord',
      component: () => import('@/views/parking-waiver/record/index.vue'),
      meta: {
        locale: '停车减免记录',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default PARKING_WAIVER;
